/**
 *
 * Asynchronously loads the component for HideIf
 *
 */

import { lazyLoad } from 'utils/loadable';

export const HideIf = lazyLoad(
  () => import('./index'),
  module => module.HideIf,
);
